import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppSelector } from '@/redux/hooks';
import { getItemSummarySellerName } from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';

export type SellerNameComponentExperimentProps = ItemSummary & { position: number };

//Experiment SEAR-769: New similar items CTA experiment
export const SellerNameComponentExperiment = createInfo<SellerNameComponentExperimentProps>({
    className: 'line-clamp-0',
    useText: ({ itemId }) => {
        const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));

        return (
            <div className="grid grid-cols-[1fr_min-content] gap-2xs">
                <BodySecondary className="truncate text-text-secondary">{sellerName}</BodySecondary>
            </div>
        );
    },
});
